<template>
  <div>
    <div class="row top-margin" v-if="documents.length === 0">
      <div class="col-lg-12">
        <div class="alert alert-info alert-dismissible" role="alert">
          No documents were found.
        </div>
      </div>
    </div>
    <div
      v-if="documents.length > 0"
      v-bind:class="{
        'table-fixed-header--md': documents.length > 6,
        'table-responsive': true,
        'bottom-margin': true,
        'overflow-y-off': true,
      }"
    >
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="text-left name-head">Name</th>
            <th class="text-left uploaded-head">Uploaded on</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="document in documents" :key="document.Key">
            <td @click="openDocument(document)" class="file file-name name-data">
              <i class="icon fa fa-file-text-o"></i
              ><a
                target="_blank"
                >{{ document.Key }}</a
              >
            </td>
            <td class="file-updated-date text-left uploaded-data">
              {{ formatDate(
                  !!document.Head  &&
                  !!document.Head.Metadata  &&
                  !!document.Head.Metadata.uploaded_at ? document.Head.Metadata.uploaded_at : document.LastModified) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import { formatDate, openUrl, logAction } from '@/util';
import logActions from '@/data/static/logActions';

export default {
  name: 'DocumentView',
  props: ['documents', 'user'],
  methods: {
    formatDate,
    ...mapActions('account', [
      'createDocumentView',
      'createAccountDocumentPresignedUrl',
    ]),
    async logDocumentViewed(doc) {
      const { Key, LastModified, ETag, Url } = doc;
      await this.createDocumentView({
        fileName: Key,
        lastModified: moment(LastModified).toDate(),
        url: Url.split('?')[0],
        Etag: ETag,
        userId: this.user.id,
        accountId: this.$route.params.accountId,
      });
      const logMessage = `User U${this.user.id} viewed ${Key} document`;
      logAction({
        user: this.user.id,
        level: 'info',
        action: logActions.DOCUMENT_VIEW.name,
        message: logMessage,
      });
    },
    async openDocument(doc) {
      const res = await this.createAccountDocumentPresignedUrl({
        accountId: this.$route.params.accountId,
        payload: {
          key: doc.OriginalKey,
        },
      });
      openUrl(res.url);
      await this.logDocumentViewed({ ...doc, Url: res.url });
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

th {
  padding: 14px 8px;
  color: #888;
  border-bottom-width: 1px;
  vertical-align: bottom;
  border-bottom: 1px solid #eee;
  border-top: 0;
  line-height: 1.52857143;
  font-weight: normal;
}

td {
  padding: 8px;
  line-height: 1.52857143;
  vertical-align: top;
  border-top: 1px solid #eee;
  height: 60px;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #fafbfc;
}

.icon {
  margin-right: 5px;
  color: #00788d;
}

.file {
  padding: 14px 8px;
}

.name-head {
  width: 70%;
}

.uploaded-head {
  width: 30%;
}

.name-data {
  width: 80%;
}

.uploaded-data {
  width: 20%;
}

.file-name a {
  color: #1c8799;
  font-weight: 600;
  text-decoration: underline;
}

.file-updated-date {
  margin: 0px 12px 0px 0px;
  padding: 14px 8px;
}

.file-updated-date {
  color: #6d6d6d;
}

.file-name:hover {
  cursor: pointer;
}

.with-right-padding {
  padding-right: 60px;
}

.table-fixed-header--md tr th:last-child {
  margin-right: 12px;
  width: 10.4%;
}

.overflow-y-off {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// DocumentView.vue?6ee9e391